var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 278.374,
    height: 107.803,
    viewBox: "0 0 278.374 107.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.015,
    y1: 0.982,
    x2: 0.109,
    y2: -0.107,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0084b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ac249"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a31a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f16622"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2",
    transform: "translate(0 0.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 -0.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1245,748.813c0,.14,0,.288-.006.428a63.676,63.676,0,0,1-38.678-31.446A31.8,31.8,0,0,1,1245,748.813Z",
    transform: "translate(-1079.141 -641.438)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M1168.593,30.766a47.655,47.655,0,0,1-25.969,42.446A63.592,63.592,0,0,1,1157.278-.06a47.426,47.426,0,0,1,11.314,30.826Z",
    transform: "translate(-1016.967 0.06)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M21.486,367.54v14.7a10.286,10.286,0,0,0-3.558-3.4,11.4,11.4,0,0,0-5.744-1.441,12.536,12.536,0,0,0-6.255,1.557,11.272,11.272,0,0,0-4.348,4.346,14.145,14.145,0,0,0,0,13A11.386,11.386,0,0,0,5.929,400.7a12.377,12.377,0,0,0,6.255,1.581,11.366,11.366,0,0,0,5.79-1.464,10.305,10.305,0,0,0,3.651-3.6v4.838h3.163V367.54Zm-1.139,27.275a8.46,8.46,0,0,1-3.257,3.347,9.229,9.229,0,0,1-4.674,1.186,9.016,9.016,0,0,1-4.6-1.186,8.679,8.679,0,0,1-3.256-3.348,10.987,10.987,0,0,1,0-10.022,8.725,8.725,0,0,1,3.256-3.325,9,9,0,0,1,4.6-1.185,9.232,9.232,0,0,1,4.674,1.185,8.5,8.5,0,0,1,3.257,3.326,11.17,11.17,0,0,1,0,10.022Z",
    transform: "translate(0 -328.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M317.8,372.23a2.338,2.338,0,0,1-1.722-.7,2.279,2.279,0,0,1-.7-1.674,2.2,2.2,0,0,1,.7-1.651,2.382,2.382,0,0,1,1.721-.675,2.425,2.425,0,0,1,1.721.652,2.134,2.134,0,0,1,.7,1.628,2.381,2.381,0,0,1-.674,1.721A2.314,2.314,0,0,1,317.8,372.23Zm-1.674,29.808V377.624h3.3v24.415Z",
    transform: "translate(-282.127 -328.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M440,466.989a11.106,11.106,0,0,0-4.209-4.372,11.945,11.945,0,0,0-6.115-1.557,11.8,11.8,0,0,0-6.115,1.6,11.52,11.52,0,0,0-4.277,4.4,12.921,12.921,0,0,0-1.558,6.417,12.637,12.637,0,0,0,1.628,6.441,11.643,11.643,0,0,0,4.515,4.414,13.523,13.523,0,0,0,6.7,1.6,13.768,13.768,0,0,0,5.37-1.023A10.476,10.476,0,0,0,440,481.94l-1.86-2.139a8.646,8.646,0,0,1-3.325,2.418,10.878,10.878,0,0,1-4.162.791,10.5,10.5,0,0,1-5.046-1.186,8.593,8.593,0,0,1-3.441-3.3,9.229,9.229,0,0,1-1.2-4.022h20.52c0-.187.007-.365.023-.536s.024-.332.024-.488A13.318,13.318,0,0,0,440,466.989Zm-17.948,1.325a8.081,8.081,0,0,1,3.115-3.255,8.836,8.836,0,0,1,4.51-1.16,8.672,8.672,0,0,1,4.511,1.16,8.4,8.4,0,0,1,3.093,3.232,9.3,9.3,0,0,1,1.093,3.744h-17.4A9.594,9.594,0,0,1,422.056,468.314Z",
    transform: "translate(-373.69 -412.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M686.893,438.049a5.328,5.328,0,0,1-3.628,1.256,4.1,4.1,0,0,1-3.139-1.16,4.64,4.64,0,0,1-1.093-3.3v-14.6h7.441V417.5h-7.441v-5.4h-3.3v5.394H671.36v2.741h4.371v14.791a7.1,7.1,0,0,0,1.861,5.255,7.183,7.183,0,0,0,5.3,1.861,9.619,9.619,0,0,0,2.814-.422,6.108,6.108,0,0,0,2.349-1.3Z",
    transform: "translate(-600.58 -368.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M885.134,463.406q-2.583-2.347-7.325-2.348a17.384,17.384,0,0,0-5.482.86,13.188,13.188,0,0,0-4.465,2.442l1.489,2.464a11.484,11.484,0,0,1,3.628-2.092,12.9,12.9,0,0,1,4.51-.791,7.217,7.217,0,0,1,5.185,1.674,6.333,6.333,0,0,1,1.745,4.79v1.488h-7.772a13.527,13.527,0,0,0-5.557.949,6.331,6.331,0,0,0-2.976,2.517,6.755,6.755,0,0,0-.907,3.464,6.513,6.513,0,0,0,1.069,3.7,7.073,7.073,0,0,0,3.092,2.511,11.6,11.6,0,0,0,4.767.907,10.727,10.727,0,0,0,5.79-1.441,7.9,7.9,0,0,0,2.627-2.629v3.838h3.163V470.54Q887.714,465.756,885.134,463.406Zm-3.674,18.649a8.824,8.824,0,0,1-4.814,1.279,7.307,7.307,0,0,1-4.557-1.256,4.244,4.244,0,0,1-.257-6.465q1.371-1.256,4.907-1.256h7.673v4a7.352,7.352,0,0,1-2.952,3.7Z",
    transform: "translate(-775.778 -412.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M1471.322,485.922a18.711,18.711,0,0,1-5.721-.86,12.257,12.257,0,0,1-4.232-2.162l1.489-2.6a14.092,14.092,0,0,0,3.813,1.929,14.66,14.66,0,0,0,4.885.814q3.489,0,5.023-1.092a3.4,3.4,0,0,0,1.535-2.907,2.691,2.691,0,0,0-.861-2.117,5.6,5.6,0,0,0-2.254-1.16,27.984,27.984,0,0,0-3.116-.675q-1.721-.278-3.418-.65a12.538,12.538,0,0,1-3.092-1.093,6.05,6.05,0,0,1-2.256-1.977,5.827,5.827,0,0,1-.86-3.348,6.063,6.063,0,0,1,1.115-3.585,7.369,7.369,0,0,1,3.28-2.488,13.656,13.656,0,0,1,5.278-.907,18.466,18.466,0,0,1,4.744.627,13.128,13.128,0,0,1,3.9,1.651l-1.441,2.651a11.1,11.1,0,0,0-3.488-1.6,14.6,14.6,0,0,0-3.719-.483,8.284,8.284,0,0,0-4.859,1.14,3.467,3.467,0,0,0-1.558,2.907,2.821,2.821,0,0,0,.86,2.186,5.911,5.911,0,0,0,2.278,1.232,23.088,23.088,0,0,0,3.121.717q1.7.278,3.395.675a15.382,15.382,0,0,1,3.116,1.069,5.738,5.738,0,0,1,2.279,1.907,5.551,5.551,0,0,1,.86,3.231,5.925,5.925,0,0,1-1.187,3.7,7.593,7.593,0,0,1-3.441,2.418A15.412,15.412,0,0,1,1471.322,485.922Z",
    transform: "translate(-1307.302 -412.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M1697.857,485.94a12.581,12.581,0,0,1-6.348-1.6,11.788,11.788,0,0,1-4.442-4.418,13.6,13.6,0,0,1,0-12.9,11.71,11.71,0,0,1,4.418-4.371,12.691,12.691,0,0,1,6.371-1.581,12.915,12.915,0,0,1,6.441,1.581,11.5,11.5,0,0,1,4.418,4.371,13.775,13.775,0,0,1,0,12.9,11.585,11.585,0,0,1-4.442,4.418A12.791,12.791,0,0,1,1697.857,485.94Zm0-2.93a9.194,9.194,0,0,0,4.7-1.186,8.511,8.511,0,0,0,3.232-3.348,11.179,11.179,0,0,0,0-10.022,8.556,8.556,0,0,0-3.232-3.325,9.717,9.717,0,0,0-9.3,0,8.716,8.716,0,0,0-3.254,3.325,10.987,10.987,0,0,0,0,10.022,8.669,8.669,0,0,0,3.254,3.347A9.021,9.021,0,0,0,1697.857,483.01Z",
    transform: "translate(-1507.749 -412.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M1974.6,485.94a13.032,13.032,0,0,1-6.488-1.6,11.7,11.7,0,0,1-4.488-4.418,13.6,13.6,0,0,1,0-12.9,11.577,11.577,0,0,1,4.488-4.371,13.182,13.182,0,0,1,6.488-1.581,12.8,12.8,0,0,1,5.627,1.209,9.132,9.132,0,0,1,3.954,3.627l-2.465,1.674a7.733,7.733,0,0,0-3.116-2.741,9.811,9.811,0,0,0-8.743.3,8.621,8.621,0,0,0-3.3,3.325,11.037,11.037,0,0,0,0,10.045,8.612,8.612,0,0,0,3.3,3.322,9.807,9.807,0,0,0,8.743.3,7.874,7.874,0,0,0,3.116-2.7l2.465,1.673a9.352,9.352,0,0,1-3.954,3.6A12.685,12.685,0,0,1,1974.6,485.94Z",
    transform: "translate(-1755.152 -412.445)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M2225.565,372.23a2.339,2.339,0,0,1-1.721-.7,2.28,2.28,0,0,1-.7-1.674,2.2,2.2,0,0,1,.7-1.651,2.382,2.382,0,0,1,1.721-.675,2.425,2.425,0,0,1,1.721.652,2.134,2.134,0,0,1,.7,1.628,2.381,2.381,0,0,1-.673,1.721A2.319,2.319,0,0,1,2225.565,372.23Zm-1.674,29.808V377.624h3.3v24.415Z",
    transform: "translate(-1988.766 -328.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M2347.374,463.406q-2.583-2.347-7.327-2.348a17.37,17.37,0,0,0-5.487.86,13.187,13.187,0,0,0-4.464,2.442l1.488,2.464a11.469,11.469,0,0,1,3.628-2.092,12.9,12.9,0,0,1,4.51-.791,7.216,7.216,0,0,1,5.186,1.674,6.336,6.336,0,0,1,1.744,4.79v1.488h-7.764a13.527,13.527,0,0,0-5.558.949,6.351,6.351,0,0,0-2.976,2.511,6.768,6.768,0,0,0-.907,3.464,6.514,6.514,0,0,0,1.069,3.7,7.073,7.073,0,0,0,3.093,2.511,11.592,11.592,0,0,0,4.766.907,10.726,10.726,0,0,0,5.79-1.441,7.9,7.9,0,0,0,2.629-2.624V485.7h3.163V470.54Q2349.957,465.756,2347.374,463.406Zm-3.673,18.649a8.816,8.816,0,0,1-4.813,1.279,7.312,7.312,0,0,1-4.559-1.256,4.243,4.243,0,0,1-.257-6.465q1.37-1.256,4.906-1.256h7.674v4A7.342,7.342,0,0,1,2343.7,482.055Z",
    transform: "translate(-2083.858 -412.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M2609.12,402.046V367.54h3.3v34.506Z",
    transform: "translate(-2334.048 -328.785)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsLogo);
export default __webpack_public_path__ + "static/media/ds-logo.19e09c0c5a92abeec37ec27e2d6e8e9b.svg";
export { ForwardRef as ReactComponent };